import Model from "flarum/common/Model";
export default class DiscussionView extends Model {
  visitedAt() {
    return Model.attribute("visitedAt", Model.transformDate).call(this);
  }
  user() {
    return Model.hasOne("user").call(this);
  }
  discussion() {
    return Model.hasOne("discussion").call(this);
  }
}
flarum.reg.add('michaelbelgium-discussion-views', 'forum/models/DiscussionView', DiscussionView);